// @ts-nocheck
const bgColor = (backgroundColor) =>
  typeof backgroundColor === "boolean" ? "lightgray" : backgroundColor;

// We always keep the resize transform to have matching sizes + aspect ratio
// If used with native height & width from Hygraph it produces no transform
const resizeImage = ({ width, height, fit }) =>
  `resize=w:${width},h:${height},fit:${fit}`;

// Filestack supports serving modern formats (like WebP) for supported browsers.
// See: https://www.filestack.com/docs/api/processing/#auto-image-conversion
const compressAndWebp = (webp: boolean) =>
  `${webp ? "auto_image/" : ""}compress`;

const constructURL =
  (handle: string, withWebp: boolean, baseURI: string) =>
  (resize) =>
  (transforms) =>
    [baseURI, resize, ...transforms, compressAndWebp(withWebp), handle].join(
      "/"
    );

// responsiveness transforms
const responsiveSizes = (size?: number) => [
  size / 4,
  size / 2,
  size,
  size * 1.5,
  size * 2,
  size * 3,
];

const getWidths = (width: number, maxWidth?: number) => {
  const sizes = responsiveSizes(maxWidth).filter((size) => size < width);
  // Add the original width to ensure the largest image possible
  // is available for small images.
  const finalSizes = [...sizes, width];
  return finalSizes;
};

const srcSet = (
  srcBase: string,
  srcWidths: number[],
  fit: string,
  transforms: string
) =>
  srcWidths
    .map(
      (width: number) =>
        `${srcBase([`resize=w:${Math.floor(width)},fit:${fit}`])(
          transforms
        )} ${Math.floor(width)}w`
    )
    .join(",\n");

const imgSizes = (maxWidth: string) =>
  `(max-width: ${maxWidth}px) 100vw, ${maxWidth}px`;

export interface ImageType {
  handle: string;
  width: number;
  height: number;
}

const Image = ({
  alt = "",
  image: { handle, width, height },
  fit = "max", //"clip"|"crop"|"scale"|"max"
  maxWidth,
  backgroundColor,
  transforms = [],
  withWebp = true,
  baseURI = "https://media.graphassets.com",
  className,
  loading = "lazy",
}: {
  image: ImageType;
  alt: string;
  fit?: "clip" | "crop" | "scale" | "max";
  maxWidth?: number;
  backgroundColor?: string | boolean;
  transforms?: string[];
  withWebp?: boolean;
  baseURI?: string;
  className?: string;
  loading?: "lazy" | "eager";
}) => {
  const srcBase = constructURL(handle, withWebp, baseURI);
  const srcWidths = getWidths(width, maxWidth);
  const src = srcBase(resizeImage({ width, height, fit }))(transforms);
  const srcSetString = srcSet(srcBase, srcWidths, fit, transforms);
  const sizes = imgSizes(maxWidth);
  return (
    <img
      alt={alt}
      src={src}
      srcSet={srcSetString}
      sizes={sizes}
      style={{ backgroundColor: bgColor(backgroundColor) }}
      className={className}
      loading={loading}
    />
  );
};

export default Image;
